import { DimensionalGoldButton } from "./ActionRow";
import "./v2-question-surface.css";

export default function StickySendButton({ onSend }) {
  return (
    <div className="tgc-v2-sticky-send">
      <div className="tgc-v2-sticky-send__scrim" aria-hidden="true" />
      <DimensionalGoldButton className="tgc-v2-button tgc-v2-button--gold tgc-v2-sticky-send__button" onClick={onSend}>
        This is them. Send it.
      </DimensionalGoldButton>
    </div>
  );
}
